import { Box } from '@mui/material';
import { Text } from '@qwickapps/react-framework';

interface ErrorDetailsProps {
  errorMessage?: string;
}

export default function ErrorDetails({ errorMessage }: ErrorDetailsProps) {
  if (!errorMessage) return null;

  return (
    <Box
      sx={{
        mt: 1,
        p: 1.5,
        bgcolor: 'rgba(0, 0, 0, 0.3)',
        borderRadius: 1,
        fontSize: '0.875rem',
      }}
    >
      <Text variant="caption" style={{ fontWeight: 'bold', display: 'block', marginBottom: 4 }}>
        Error Details:
      </Text>
      <Text variant="caption" component="pre" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        {errorMessage}
      </Text>
    </Box>
  );
}
